import React, { useState } from 'react';

import StockMobileSidePanel from '@/components/StockMobileSidePanel';
import {
  FilterButton,
  FilterButtonWrapper,
  FiltersWrapper,
  MobileFilterItemWrapper,
} from '@/modules/CarsStock/components/common.styles';

import BrandFilter from './components/BrandFilter';
import ModelFilter from './components/ModelFilter';
import ComplectationFilter from './components/ComplectationFilter';
import { ModelsFilterProps } from './types';

function ModelsFilter({ carsType }: ModelsFilterProps) {
  const [isOpened, setOpened] = useState(false);

  const handleSidePanelOpen = () => {
    setOpened(true);
  };

  const handleSidePanelClose = () => {
    setOpened(false);
  };

  return (
    <FiltersWrapper>
      <StockMobileSidePanel
        title={`Марка, модель${carsType === 'new' ? ', комплектация' : ''}`}
        zIndex={10001}
        isInnerSidePanel
        isOpened={isOpened}
        onOpen={handleSidePanelOpen}
        onClose={handleSidePanelClose}
      >
        <MobileFilterItemWrapper>
          <BrandFilter />
        </MobileFilterItemWrapper>
        <MobileFilterItemWrapper>
          <ModelFilter />
        </MobileFilterItemWrapper>
        {carsType === 'new' && (
          <MobileFilterItemWrapper>
            <ComplectationFilter />
          </MobileFilterItemWrapper>
        )}

        <FilterButtonWrapper>
          <FilterButton onClick={handleSidePanelClose}>Применить</FilterButton>
        </FilterButtonWrapper>
      </StockMobileSidePanel>
    </FiltersWrapper>
  );
}

export default ModelsFilter;
